"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    panel: 'Panel',
    subPanel: 'SubPanel'
  },
  fr: {
    panel: 'Panneau',
    subPanel: 'Sous-Panneau'
  }
};